/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_SavingInputs */

const en_confirm_saving = /** @type {(inputs: Confirm_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const he_confirm_saving = /** @type {(inputs: Confirm_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שומר…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Confirm_SavingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_saving = /** @type {((inputs?: Confirm_SavingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_SavingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_saving(inputs)
	return he_confirm_saving(inputs)
});